module.exports = __webpack_public_path__ + "static/media/ktm-04.9e84bc89.jpg";